
import { AWSFile } from "@/models/aws-file";
import { Image } from "@/utils/label-layout/image";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import {  Model } from "@/utils/models/model";
import Vue from "vue";
import AppImageSettings from "./ImageSettings.vue";
import AppImagesList from "./ImagesList.vue";

export default Vue.extend({
	data(){
		return {
			toEditImageIndex: -1,
			newImageModalOpen: false,
			newImageAwsTokenModalOpen: false,
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		model():Model{
			return this.layout.getModel();
		}
	},
	methods: {
		addNewImage(){
			this.newImageModalOpen = true;
		},
		deleteImage(i:number){
			this.layout.Images.splice(i,1);
		},
		editImage(image:Image){
			this.toEditImageIndex = this.layout.Images.indexOf(image);
		},
		openSelectImageModal(){
			this.newImageModalOpen = false;
			this.newImageAwsTokenModalOpen = true;
		},
		createNewImageFromProperty(){
			this.newImageAwsTokenModalOpen = false;
			this.newImageModalOpen = false;
			let image = new Image();
			image.UseImageToken = false;
			this.layout.Images.push(image);
			this.toEditImageIndex = this.layout.Images.length-1;
		},
		createNewStaticImage(file:AWSFile){
			let image = new Image();
			image.ImageToken = file.Token;
			image.UseImageToken = true;
			this.layout.Images.push(image);
		}
	},
	components: {
		AppImageSettings,
		AppImagesList
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
